import { Component, OnInit } from '@angular/core';
// Services
import { ElasticService } from './../../services/elastic';
// External
import { Club } from './../../models/club';

import * as lodash from 'lodash';
import { ApiService } from './../../services/api';
import { DatePipe } from '@angular/common';
import { AngularFireDatabase } from 'angularfire2/database';


@Component({selector : 'app-version',
    templateUrl: './app.version.component.html'
})
export class AppVersionComponent implements OnInit {
    public updateAversion = false;
    public updateIversion = false;
    public imageLoader = true;
    public androidHistory = [];
    public iosHistory = [];

    public isAndroidHistory = false;
    public isIosHistory = false;

    public android = {
        versionName: '',
        versionCode: '',
        code: '',
        description: "",
        releasedAt: '',
        appType: "1",
        $value: "",
        version: ""


    };
    public ios = {
        versionName: '',
        versionCode: '',
        code: '',
        description: "",
        releasedAt: '',
        appType: "1",
        $value: "",
        version: ""
    };
    constructor(private apiService: ApiService, private fireDatabase: AngularFireDatabase) {

    }
    ngOnInit(): void {


        this.onInit()
    }

    public onInit() {
        this.androidHistory = []
        this.iosHistory = []
        this.apiService.object("currentVersion/2").then((result) => {
            if (result) {
                this.android = result;

            }
        })

        this.apiService.object("currentVersion/1").then((result) => {
            if (result) {
                this.ios = result
            }
        })

        this.apiService.list("currentVersion/android").then((result) => {
            if (result) {
                this.androidHistory = result
            }
        })
        this.apiService.list("currentVersion/ios").then((result) => {
            if (result) {
                this.iosHistory = result
            }
        })


        this.imageLoader = false
    }

    public androidSubmit() {
        this.android.releasedAt = "" + new Date().getTime() / 1000,

            delete this.android.$value
        this.android.version = this.android.versionCode
        this.apiService.set("currentVersion/2", this.android)
        this.apiService.push("currentVersion/android", this.android)
        alert('Android Version Updated Successfully')
        location.reload();

    }
    public iosSubmit() {
        this.ios.releasedAt = "" + new Date().getTime() / 1000
        delete this.ios.$value
        this.ios.version = this.ios.versionCode

        this.apiService.set("currentVersion/1", this.ios)
        this.apiService.push("currentVersion/ios", this.ios)
        alert('IOS Version Updated Successfully')
        location.reload();

    }
}
